<template>
  <content-layout>
    <template #header>Deleted Portfolios</template>
    <template #description>Portfolios that have been deleted. Activate one to bring it back for its owner.</template>

    <el-table
      v-loading="loading"
      :data="portfolios"
      empty-text="No deleted portfolios"
      style="width: 100%">
      <el-table-column
        prop="title"
        label="Title"
        min-width="320">
      </el-table-column>
      <el-table-column
        prop="userFirstName"
        label="Creator"
        width="180">
      </el-table-column>
      <el-table-column
        label="Date"
        width="140">
        <template slot-scope="scope">
          {{getDate(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column width="200" align="right">
        <template slot-scope="scope">
          <a :href="`https://lavishlocations.com/portfolios/${scope.row._id}`" target="_blank" class="view-link">
            View <i class="el-icon-top-right"></i>
          </a>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="activatePortfolio(scope.row)">Activate
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </content-layout>
</template>
<script>
  const moment = require('moment');
  export default {
    data() {
      return {
        authConfig: {headers: {Authorization: localStorage.getItem('Authorization')}},
        portfolios: [],
        loading: true,
      }
    },

    methods: {
      async activatePortfolio(portfolio) {
        try {
          await this.$confirm(`Bring back "${portfolio.title}"? It will show in its owner's account again.`, 'Activate portfolio', {
            confirmButtonText: 'Activate',
            cancelButtonText: 'Cancel',
          });
        } catch (cancelled) {
          return;
        }
        try {
          await this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/portfolios/adminArchived/reActivate/${portfolio._id}`, this.authConfig);
          this.portfolios = this.portfolios.filter(p => p._id !== portfolio._id);
          this.$notify({message: 'Portfolio activated', type: 'success'});
        } catch (err) {
          this.$notify.error({message: `Couldn't activate the portfolio: ${err}`});
        }
      },

      getDate(portfolio) {
          if(portfolio.createdAt) {
            return moment(portfolio.createdAt).format('DD-MM-YYYY');
          } else if(portfolio.adminArchivedDate) {
            return moment(portfolio.adminArchivedDate).format('DD-MM-YYYY');;
          } else {
            return '';
          }
      }
    },

    async created() {
      this.portfolios = await this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/portfolios/adminArchived`, this.authConfig).then(response => response.data);
      this.loading = false;
    }
  }
</script>

<style scoped>
  .view-link {
    margin-right: 16px;
    color: var(--lav-green-dark);
    font-weight: 600;
    text-decoration: none;
  }

  .view-link:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/DeletedPortfolios.vue